import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function View({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 17 10'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M15.4995 4.61645C15.7476 4.9513 15.9154 5.21559 16.0036 5.37437C16.1377 5.61576 16.0507 5.92016 15.8093 6.05427C15.5679 6.18837 15.2635 6.1014 15.1294 5.86001C15.0614 5.73754 14.9167 5.50963 14.696 5.21168C14.3243 4.70989 13.8775 4.20729 13.357 3.73883C12.5029 2.97009 11.5536 2.38087 10.5079 2.02067C11.309 2.7084 11.8165 3.72851 11.8165 4.86719C11.8165 6.93833 10.1376 8.61719 8.0665 8.61719C5.99535 8.61719 4.3165 6.93833 4.3165 4.86719C4.3165 3.72851 4.82395 2.7084 5.62506 2.02067C4.57935 2.38088 3.63014 2.97009 2.77598 3.73883C2.25548 4.20729 1.80872 4.70989 1.43703 5.21168C1.21632 5.50963 1.07162 5.73754 1.00358 5.86001C0.869469 6.1014 0.565068 6.18837 0.323676 6.05427C0.082284 5.92016 -0.00468789 5.61576 0.129419 5.37437C0.21763 5.21559 0.385429 4.9513 0.633469 4.61645C1.04302 4.06355 1.53377 3.51146 2.10701 2.99554C3.75514 1.51223 5.74412 0.617188 8.0665 0.617188C10.3889 0.617188 12.3779 1.51223 14.026 2.99554C14.5992 3.51146 15.09 4.06355 15.4995 4.61645ZM8.0665 2.11719C6.54764 2.11719 5.3165 3.34833 5.3165 4.86719C5.3165 6.38604 6.54764 7.61719 8.0665 7.61719C9.58535 7.61719 10.8165 6.38604 10.8165 4.86719C10.8165 3.34833 9.58535 2.11719 8.0665 2.11719Z' />
    </svg>
  );
}
